import { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { resolve as resolveEnv } from 'core/utils/env';

import ExchangeContext from './ExchangeContext';


const fenwickHost = resolveEnv({
  '*': 'https://s1.fenwick.unity.rambler.ru',
  'production': 'https://fenwick.unity.rambler.ru',
});

const fenwickBaseUrl = `${fenwickHost}/api/v1/sites`;

export default class ExchangeProvider extends Component {
  static contextTypes = {
    siteName: PropTypes.string,
  };

  state = {
    config: null,
  };

  componentDidMount() {
    if (!process.env.BROWSER_RUNTIME) return;

    const fenwickUrl = resolveEnv({
      '*': `${fenwickBaseUrl}/${this.context.siteName}`,
      'production': '/fenwick',
    });

    axios.get(fenwickUrl)
      .then(response => response.data)
      .then(config => this.setState({ config }))
      .catch(console.error);
  }

  render() {
    return (
      <ExchangeContext.Provider value={this.state.config}>
        {this.props.children}
      </ExchangeContext.Provider>
    );
  }
}
